module.exports = __webpack_public_path__ + "img/logo.59270d07.png";